import React from "react";
import Slider from "react-slick";
import "./testimonial.css";

import user1 from "../Assets/kiran.png";
import user2 from "../Assets/veena.png";

import quote from "../Assets/icon.png";
// Don't forget to import slick CSS in your entry file (e.g., App.js or index.js)
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const testimonialsData = [
  {
    username: "Mr Kiran Shah",
    desc: "Being the primary caregiver for my 82-year-old mother was overwhelming—both physically and emotionally. I wanted to give her the best care, but I needed support. That’s when your elderly care team stepped in. From daily assistance to managing her medications and mobility, the care professionals made all the difference. They didn’t just care for her—they supported me too. I could finally breathe, knowing she was in safe, compassionate hands at home.",
    userimg: user1,
  },
  {
    username: "Mrs Veena Thomas",
    desc: "Recovering from knee replacement surgery was daunting until I started physiotherapy sessions at home with your team. The therapist was experienced, friendly, and came equipped with everything needed. They patiently guided me through each session, and within just a few weeks, I felt stronger and more confident.",
    userimg: user2,
  },
  {
     username: "Mrs Srikanth",
    desc: "Home physiotherapy care from wihan made all the difference in my recovery journey. After my surgery, I was hesitant about going to a clinic for therapy, but having the physiotherapist come to my home was a game-changer. Their personalized approach and attention to detail helped me regain strength and mobility faster than I ever expected. I felt comfortable and motivated during each session, and I could see the progress week by week. I'm grateful for their support and expertise, and I would highly recommend home physiotherapy to anyone looking for convenient and effective rehabilitation.",
    userimg: user2,
  },
];

const Testimonials = ({ title, subtitle, data = [], textKey, imgKey, nameKey, className }) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768, // tablet
        settings: {
          slidesToShow: 2,
        },

      },
      {
        breakpoint: 480, //mobile
        settings: {
          slidesToShow: 1,
        },

      },
    ],
  };

  function truncateLetters(text, maxLetters = 260) {
    let letterCount = 0;
    let result = "";

    for (let char of text) {
      if (/[a-zA-Z]/.test(char)) {
        letterCount++;
      }
      if (letterCount > maxLetters) break;
      result += char;
    }

    return letterCount > maxLetters ? result.trim() + "..." : result;
  }
  return (
    <section className={`testimonials-section ${className || ""}`}> 
      <h2 className="testimonials-title">

        {title || (data?.length > 0 ? data[0].title : "Testimonials")}
      </h2>

      {subtitle && <p className="testimonials-subtitle">{subtitle}</p>}

      <div className="slider-wrapper">
        <Slider {...settings}>
          {data.map((item, index) => (
            <div key={item.id || index} className="testimonial-card">
              <img src={quote} alt="quote" className="quote-img" />
              <p className="testimonial-text">
                “{truncateLetters(item[textKey], 260)}”
              </p>
              <div className="testimonial-user">
                <img
                  src={item[imgKey]}
                  alt={item[nameKey]}
                  className="user-img"
                />
                <h4 className="user-name">{item[nameKey]}</h4>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
